<template>
  <div class="non_card__wrap">
    <div v-if="simcard" class="non_card">
      <div class="header-profile">

        <div v-if="profile.traffic" class="traffic__wrap"
             :title="translate('simcard_profile.balance_traffic') + ': ' + profile.traffic.rest + ' Mb'">
          <div class="traffic" :style="style_traffic">
            <p v-if="profile.traffic.limit && profile.traffic.ts_update">
              <b :style="'color:' + balance_traffic?.color"> {{ balance_traffic?.traffic }} </b>
              <span>
                {{ translate("simcard_devices.out_of") }}
                <b>
                  {{ profile.traffic.limit > 1024 * 5 ? Math.round(profile.traffic.limit / 1024) + ' GB' :
                    profile.traffic.limit + ' MB' }}
                </b>
              </span>
            </p>
          </div>
          <div class="last_update" v-if="profile.traffic.limit && profile.traffic.ts_update">
            <p>
              {{ translate('simcard_devices.updated') }}
              {{ last_update }}
            </p>
          </div>
        </div>

        <div class="miniblocks">

          <div class="miniblock status_info card" :class="{ online: simcard.active, offline: !simcard.active, }">
            <div class="icons">
              <span class="icon mdi mdi-access-point-off offline" v-if="!simcard.active"/>
              <span class="icon mdi mdi-access-point online" v-if="simcard.active"/>
            </div>

            <div class="text">
              <p>
                {{ simcard.ts_sync === 0 ? translate('simcard_profile.off_forever') : (simcard.active) ? translate('simcard_profile.on_since') : translate('simcard_profile.off_since') }}
              </p>
              <p>
                {{ uptimeStr }}
              </p>
              <p>
                {{ last_date }}
              </p>
            </div>
          </div>

          <div
              class="miniblock simcard_info card"
              :class="getColorSimcardProfileStatuses(+simcard.status)"
          >
            <p>{{ translate(getTextSimcardProfileStatuses(+simcard.status)) }} </p>
            <p>{{ get_status_from }}</p>
            <p v-if="simcard.status !== -1 && simcard.ts_update !== 0">{{ simcard.tariff }}</p>
          </div>
        </div>


        <div class="linked-cards" v-if="Object.keys(links).length > 0">
          <div class="linked-card__wrap" v-for="(link, key) in links" :key="key">
            <LinkedSimCard v-if="link != null" :title="key" :simcard="link" />
          </div>
        </div>
      </div>

      <ActionsSB v-if="profile.imsi" :sim_id="profile.imsi" :profile="profile"> </ActionsSB>

      <button
          v-if="$store.getters.getPermissions.controlSimcardProfile"
          type="button"
          class="btn btn-success btn-fill"
          :disabled="!profile.iccid"
          @click="create_sim_task"
      >
        <i class="mdi mdi-plus-circle-outline" />{{ translate('sim_task_list.task_list.create_sim_task') }}
      </button>

      <div class="content">
        <div class="title">
          <h4>{{ translate('simcard_devices.main_info') }}</h4>
          <button class="btn-info btn-fill btn-wd" @click.prevent="change_status">
            {{ translate('simcard_profile.change_status') }}
          </button>
        </div>
        <div class="card">
          <div class="row">
            <div class="col-md-2">
              <div class="fg-wrapper">
                <fg-input v-model="simcard.msisdn" type="text" :label="translate('simcard_profile.msisdn')"
                          :placeholder="translate('simcard_profile.msisdn')" :readonly="true"
                />
                <div class="minibtn mno_link" v-if="simcard.mno_link">
                  <a :href="simcard.mno_link" target="_blank">
                    <span class="mdi mdi-open-in-new"></span>
                  </a>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <fg-input v-model="simcard.imsi" type="text" :label="translate('simcard_profile.imsi')"
                        :placeholder="translate('simcard_profile.imsi')" :readonly="true" />
            </div>

            <div class="col-md-3">
              <fg-input v-model="simcard.iccid" type="text" :label="translate('simcard_profile.iccid')"
                        :placeholder="translate('simcard_profile.iccid')" :readonly="true" />
            </div>

            <div class="col-md-2">
              <label> {{ translate('simcard_profile.simcard_apn') }} </label>
              <div class="simcard-apn">
                <tree-select
                    v-model="simcard.simcard_operator_apn_id"
                    :options="simcard_apn_list"
                    :placeholder="translate('simcard_profile.simcard_apn')"
                    :clearable="false"
                    :disabled="simcard.simcard_operator_apn_id !== null"
                    @select="change_simcard_apn"
                />
                <button
                    v-if="$store.getters.getPermissions.permissionGod === true && simcard.simcard_operator_apn_id != null"
                    type="button"
                    class="apn-reset mdi mdi-close pointer"
                    :title="translate('simcard_profile.reset_apn')"
                    :aria-label="translate('simcard_profile.reset_apn')"
                    @click="confirm_reset_apn"
                />
              </div>
            </div>
            <div class="col-md-2">
              <fg-input
                  :value="simcard.apn_ip"
                  type="text"
                  :label="translate('simcard_profile.apn_ip')"
                  :placeholder="translate('simcard_profile.apn_ip')"
                  :readonly="true"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-sm-4">
              <router-link :to="get_mo_link(simcard.mno_name)">
                <fg-input v-model="simcard.mno_name" type="text" :label="translate('simcard_profile.mno')"
                          :placeholder="translate('simcard_profile.mno')" :readonly="true"/>
              </router-link>
            </div>
            <div class="col-md-4 col-sm-4">
              <router-link :to="get_tariff_link(simcard.tariff_id)">
                <fg-input v-model="simcard.tariff" type="text" :label="translate('simcard_profile.tariff')"
                          :placeholder="translate('simcard_profile.tariff')" :readonly="true">
                </fg-input>
              </router-link>
            </div>
            <div class="col-md-4 col-sm-4">
              <fg-input v-model="simcard.tariff_ap" type="text" :label="translate('simcard_profile.tariff_ap')"
                        :placeholder="translate('simcard_profile.tariff')" :readonly="true">
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-sm-4">
              <fg-input v-model="oper_account" type="text" :label="translate('simcard_profile.oper_account')"
                        :placeholder="translate('simcard_profile.oper_account')" :readonly="true" />
            </div>
            <div class="col-md-4 col-sm-4">
              <fg-input v-model="date_start" type="text" :label="translate('simcard_profile.ts_create')"
                        :placeholder="translate('simcard_profile.ts_create')" :readonly="true" />
            </div>
            <div class="col-md-4 col-sm-4">
              <fg-input v-model="date_update" type="text" :label="translate('simcard_profile.ts_update')"
                        :placeholder="translate('simcard_profile.ts_update')" :readonly="true">
              </fg-input>
            </div>
          </div>
        </div>
      </div>

      <div class="bindings" v-if="simcard.bindings">
        <div class="title">
          <h4>{{ translate('simcard_devices.binded_device') }}</h4>
        </div>
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <router-link :to="'/device/' + simcard.bindings.device_fid" class="link">
                <fg-input
                    v-model="binding_device"
                    type="text"
                    :label="translate('simcard_devices.in_device')"
                    :placeholder="translate('simcard_devices.in_device')"
                    :readonly="true"
                />
              </router-link>
            </div>

            <div class="col-md-4">
              <fg-input
                  v-model="simcard.bindings.slot"
                  type="text"
                  :label="translate('simcard_devices.slot')"
                  :placeholder="translate('simcard_devices.slot')"
                  :readonly="true"
              />
            </div>

            <div class="col-md-4">
              <fg-input
                  v-model="simcard.bindings.user_name"
                  type="text"
                  :label="translate('simcard_devices.user')"
                  :placeholder="translate('simcard_devices.user')"
                  :readonly="true"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                  v-model="binding_created"
                  type="text"
                  :label="translate('simcard_devices.created')"
                  :placeholder="translate('simcard_devices.created')"
                  :readonly="true"
              />
            </div>
            <div class="col-md-4">
              <fg-input
                  v-model="binding_updated"
                  type="text"
                  :label="translate('simcard_devices.updated')"
                  :placeholder="translate('simcard_devices.updated')"
                  :readonly="true"
              />
            </div>
            <div class="col-md-4">
              <fg-input
                  v-model="binding_verify"
                  type="text"
                  :label="translate('simcard_devices.verify')"
                  :placeholder="translate('simcard_devices.verify')"
                  :readonly="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="simcard_list">
        <RelatedProfiles v-if="profile.related_profiles" title="Related Profiles"
                         :simcard_list="profile.related_profiles" />
      </div>

      <div class="simcard_list">
        <DeviceHistory
            v-if="profile.imsi"
            :title="translate('simcard_devices.section.device_history')"
            :profile="profile"
        />
      </div>


    </div>


    <div class="history_action__wrap">
      <Summary type="simcard_profile" :info="simcard" />
    </div>
  </div>
</template>
<script>

import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";
import RelatedProfiles from './RelatedProfiles.vue'
import DeviceHistory from "./DeviceHistory.vue";
import LinkedSimCard from 'components/UIComponents/Icon/LinkedSimCard.vue'
import Summary from "components/UIComponents/Summary/Summary.vue";
import ChangeStatus from "./Modal/ChangeStatus/Index.vue";
import ActionsSB from "./Actions/ActionsSB.vue";
import Actions from "../Actions/Index.vue";
import CreateSimTask from "components/UIComponents/SimTask/CreateSimTask.vue";

export default {
  components: {
    Actions,
    RelatedProfiles,
    DeviceHistory,
    ActionsSB,
    LinkedSimCard,
    Summary
  },

  props: {
    profile: {
      type: [Array, Object],
      default: () => []
    }
  },

  created() {
    this.update_sim()
    this.check_links(this.simcard)
  },
  data() {
    return {
      ch_group: false,
      showBlock: true,
      simcard: {
        type: [Array, Object],
        default: () => []
      },
      editNumber: true,
      editOperator: true,
      links: {},
      uptimeStr: ""
    }
  },

  computed: {
    simcard_apn_list(){
      const simcard_mno = this.$store.getters.getSimcardMno.find(mno => {
        if (mno.id === this.simcard.mno_id) return mno
      })
      if (simcard_mno){
        return this.$store.getters.getSimcardOperatorApn.map((apn) => {
          if (simcard_mno.id === apn.mno_id) return { id: apn.id, label: apn.name }
        }).filter((element) => { return element !== undefined })
      }
      else{
        return []
      }
    },
    binding_created(){
      return this.get_date(this.simcard.bindings.ts_create)
    },
    binding_updated(){
      return this.get_date(this.simcard.bindings.ts_update)
    },
    binding_verify(){
      return this.get_date(this.simcard.bindings.ts_verify)
    },
    binding_device(){
      return `${this.simcard.bindings.device_fid} / ${this.simcard.bindings.device_name}`
    },
    oper_account(){
      if(this.simcard.oper_account === null) {
        return ''
      }
      return this.simcard.oper_account
    },
    date_start(){
      return this.simcard.ts_create > 0 ? this.get_date(this.simcard.ts_create ) : ''
    },
    date_update(){
      return this.simcard.ts_update > 0 ? this.get_date(this.simcard.ts_update) : ''
    },
    last_date(){
      return this.get_date(this.simcard.ts_sync, {
        hour12: false,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    },
    imsi_and_iccid() {
      return {
        imsi: this.simcard.imsi,
        iccid: this.simcard.iccid
      }
    },
    opt_groups() {
      return this.$store.getters.getSimcardDevicesGroupsTree
    },
    balance_traffic() {
      return this.traffic_balance(this.simcard.traffic)
    },

    style_traffic() {
      return this.traffic_style(this.simcard.traffic)
    },

    last_update() {
      let ts = new Date().getTime() / 1000
      var duration = Math.round(ts - this.simcard.traffic.ts_update);
      let minutes = 0
      let hours = Math.round((duration / (60 * 60)));
      if (hours < 5) {
        minutes = Math.round((duration / 60));
        return minutes + " " + this.translate('simcard_devices.min_ago')
      } else if (hours > 100) {
        let days = Math.round(((duration / 60) / 60) / 24);
        hours = Math.round(((duration / 60) % 60) % 24);
        return days + " " + this.translate('simcard_devices.d_ago') + " " + hours + " " + this.translate('simcard_devices.h_ago')
      }
      return hours + " " + this.translate('simcard_devices.h_ago')
    },
    get_status_from() {
      if (this.profile.ts_status_update){
        return "from " + this.get_date(this.profile.ts_status_update);
      }else{
        return this.translate('simcard_profile.no_lk')
      }
    },
  },

  watch: {
    profile: {
      deep: true,
      handler() {
        this.update_sim()
        this.check_links(this.simcard)
      }
    }
  },

  methods: {
    create_sim_task() {
      let t = this.$createElement(CreateSimTask, {
        props: {
          iccid: this.profile.iccid,
          sim_task_types: this.profile.sim_task_types
        },
        on: {
          close: () => {
            this.$modal.hide('create_sim_task')
          },
          update: () => {
            this.$modal.hide('create_sim_task')
            this.$emit('update')
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'create_sim_task'
      })
    },
    change_status() {
      let t = this.$createElement(ChangeStatus, {
        props: {
          simcard: this.simcard,
        },
        on: {
          close: () => {
            this.$modal.hide("change_status_modal");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
          temp,
          {},
          {
            height: "auto",
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: "change_status_modal",
          }
      );
    },
    confirm_reset_apn() {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('simcard_profile.confirm_reset_apn')
        },
        on: {
          close: () => {
            this.$modal.hide('confirm_reset_apn')
          },
          confirm: () => {
            this.$http.simcard.deleteSimcardApn(this.profile.id, () => {
              this.global_notify('info', this.translate('simcard_profile.simcard_apn_updated'))
              this.$emit('update')
            })
            this.$modal.hide('confirm_reset_apn')
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'confirm_reset_apn'
      })
    },
    change_simcard_apn(option){
      const params = {
        simcard_operator_apn_id: option.id
      }
      this.$http.simcard.putSimcardApn(this.profile.id, params, () => {
        this.global_notify('info', this.translate('simcard_profile.simcard_apn_updated'))
        this.$emit('update')
      })
    },
    get_mo_link(mno) {
      return { path: "/simcard_profile_list?mno=" + mno };
    },
    get_tariff_link(tariff_id) {
      return { path: "/simcard_profile_list?tariff=" + tariff_id };
    },
    uptimeToStr () {
      let str = ''

      if (this.simcard.ts_sync !== null) {
        let timeUp = Math.round(Date.now() / 1000) - (this.simcard.ts_sync + 1)

        let days = Math.floor((timeUp / 86400))
        str += (days > 0) ? days + ' ' + this.translate('date.d') + ' ': ''

        let hours = Math.floor((timeUp % 86400) / 3600)
        str += (hours > 0) ? hours + ' ' + this.translate('date.h') + ' ': ''

        let min = Math.floor((timeUp % 3600) / 60)
        str += min + ' ' + this.translate('date.min') + ' '

        if (!days){
          let sec = Math.floor((timeUp % 60))
          str += sec + ' ' + this.translate('date.sec') + ' '
        }
      }else{
        str += this.translate('simcard_profile.off_forever')
      }

      this.uptimeStr = str
    },
    check_links(sim) {
      let links = {}
      for (let index in sim.simcard_data) {
        if (index !== 'status' && index !== 'simcard_profile' && sim.simcard_data[index]) {
          links[index] = sim.simcard_data[index]
        }
      }
      this.$set(this, 'links', links)
    },
    update_sim() {
      this.simcard = Object.assign({}, this.profile)
      !this.simcard.number ? this.editNumber = false : this.editNumber = true
      !this.simcard.operator ? this.editOperator = false : this.editOperator = true
    },

    cancel() {
      this.init = true
      this.simcard = Object.assign({}, this.profile)
    },
  }
}

</script>

<style lang='scss' scoped>
.simcard-apn {
  position: relative;
  .apn-reset {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    border: 0;
    background: transparent;
    color: #eb5e28;
    font-size: 20px;
    padding: 0 5px;
  }
}

.non_card {
  padding-left: 0;
  padding-right: 0;
  width: calc(70% - 10px);
  margin-right: 10px;

  &__wrap {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .header-profile {
    padding-bottom: 10px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 74px;

    .icons {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;

      .badge {
        padding: 10px;
        margin-right: 10px;
      }
    }

    .linked-cards {
      height: 100px;
      display: flex;
      cursor: pointer;
      margin-left: 10px;

      .linked-card__wrap {
        height: 100%;
        margin-right: 5px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

  }

  .bindings {
    width: 100%;
    padding-bottom: 10px;

    .title{
      position: relative;
      h4{
        font-size: 12px;
        line-height: 120%;
        font-weight: bold;
        color: #252422;
        margin-top: 0;
        margin-bottom: 10px;
      }
    }
    .card{
      width: 100%;
      padding: 10px;
      a{
        display: flex;
        justify-content: space-around;
      }
      .form-group{
        width: 100%;
      }
      span{
        font-size: 12px;
        line-height: 120%;
        font-weight: bold;
        color: #252422;
      }
    }
  }

  .content {
    .title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
      h4 {
        font-size: 12px;
        line-height: 120%;
        font-weight: bold;
        color: #252422;
        margin: 0;
      }
    }
    .card {
      width: 100%;
      padding: 10px;
      margin-bottom: 10px;
      //.link {
        .form-group {
          color: #68B3C8 !important;
          .form-control {
            color: #68B3C8 !important;
          }
          input {
            color: #68B3C8 !important;
          }
          fg-input {
            color: #68B3C8 !important;
          }
        }
      //}
      .mno_link{
        .mdi{
          color: #66615b;
        }
      }
    }
  }

  .buttons{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }

  .button_div {
    padding-bottom: 10px;
    padding-top: 5px;
  }

  .table_ip_tr {
    background-color: #eee !important;
  }
}

.history_action__wrap {
  width: 30%;
  height: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px #ccc5b980;
  color: #252422;
  padding-bottom: 10px;
  position: relative;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
}


@media (max-width:1350px) {
  .card {
    width: 100%;
    height: auto;
    min-height: inherit;
    margin-bottom: 10px;

    &__wrap {
      height: auto;
      flex-direction: column;
      padding-bottom: 10px;
    }
  }

  .history_action__wrap {
    width: 100%;
    height: auto;
  }
}

@media (max-width:768px) {
  .card {
    .header-profile {
      flex-direction: column;
      .miniblocks {
        &.mr10{
          margin-right: 0;
        }
      }
      & > *{
        margin-bottom: 10px;
      }
    }
  }
}

@media (max-width:500px) {
  .card {
    .header-profile {
      .miniblocks {
        flex-direction: column;
        .miniblock{
          margin: 0 0 10px 0;
        }
      }
    }
    .content {
      align-items: center;
      flex-direction: column;
    }
  }
}

.traffic {
  --p: 10;
  --b: 10px;
  --c: darkred;
  --w: 100px;

  width: 100px;
  margin: 0 auto;
  aspect-ratio: 1;
  position: relative;
  place-content: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  p {
    font-size: 12px;
    line-height: 120%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &:before,
  &:after {
    content: "";
    position: absolute;
    border-radius: 50%;
  }

  &:before {
    inset: 0;
    background:
        radial-gradient(farthest-side, var(--c) 98%, #0000) top/var(--b) var(--b) no-repeat,
        conic-gradient(var(--c) calc(var(--p)*1%), #0000 0);
    mask: radial-gradient(farthest-side, #0000 calc(99% - var(--b)), #000 calc(100% - var(--b)));
    background-size: 0 0, auto;
    z-index: 1;
  }

  &:after {
    border: 10px solid #e3e3e3;
    width: 100%;
    height: 100%;
  }

  &__wrap {
    width: 230px;
    margin-right: 10px;

    .last_update {
      margin-top: 5px;
      text-align: center;
      display: inline-block;
      width: 100%;

      p {
        font-size: 12px;
        margin-bottom: 0;
      }
    }
  }
}

</style>
